import React, {ChangeEvent} from 'react';
import {Box} from '@mui/material';
import ArrTransferList, {
  KeyValue,
} from '../../../../common/arr-transfer-list/ArrTransferList';
import ArrReorderList from './edit-panel-sortable-item/EditPanelReorderList';
import {t} from 'i18next';
import ArrTabFocusProvider from '../../../../common/arr-tab-focus/ArrTabFocusProvider';
interface TabPanelProps {
  selectedAssignedList: KeyValue[];
  availableAssignedList: KeyValue[];
  checkColumnList: KeyValue[];
  handleAssignChange(
    event: ChangeEvent<HTMLInputElement>,
    field: KeyValue
  ): void;
  onReorderSelected?: (newOrder: KeyValue[]) => void;
  onHeaderAction?: () => void;
  onRemoveSelected?: (field: KeyValue) => void;
  headerActionDisable: boolean;
}

export const TabPanel = ({
  handleAssignChange,
  selectedAssignedList,
  availableAssignedList,
  checkColumnList,
  onReorderSelected,
  onHeaderAction,
  onRemoveSelected,
  headerActionDisable,
}: TabPanelProps) => {
  return (
    <Box
      className="column-display-panel"
      data-tab-group="minDocList"
      data-tab-id="available-list"
    >
      <ArrTabFocusProvider id="edit-doc-list">
        <Box
          className="available-list"
          data-tab-group="edit-doc-list"
          data-tab-id="available-list"
        >
          <ArrTransferList
            showCheckbox
            selectedList={checkColumnList}
            displayedList={availableAssignedList}
            onChange={handleAssignChange}
            checkboxDataTestId="tab-panel-edit-field-available-transfer-list-checkbox"
            title={t('docView.editpanel.available')}
            showHeaderAction
            headerActionLabel={t('docView.editpanel.addtoSelected')}
            onHeaderAction={onHeaderAction}
            headerActionDisable={headerActionDisable}
          />
        </Box>
        <Box
          className="selected-list"
          data-tab-group="edit-doc-list"
          data-tab-id="reorder-list"
        >
          <ArrReorderList
            title={` ${t('docView.editpanel.selected')} (${selectedAssignedList.length})`}
            items={selectedAssignedList}
            onReorder={(order) => onReorderSelected?.(order)}
            onRemove={(field) => onRemoveSelected?.(field)}
          />
        </Box>
      </ArrTabFocusProvider>
    </Box>
  );
};
